import { getAxiosClient } from "../../axios-client";
import {
  ChangeOrderStatusRequestBody,
  ChangeOrderStatusResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const changeOrderStatus = async (body: ChangeOrderStatusRequestBody) => {
  return await axiosClient.ax.put<ChangeOrderStatusResponse>(
    "/Orders/ChangeStatus",
    body
  );
};
